export default "__VITE_ASSET__0uPCc9Lx__"